import { STORE_BILLING_STATUS } from "../../constants";

const handleIsStripeSubscriptionActive = (billing) => {
  const storeBilling = billing?.billing || billing || {};
  return (
    storeBilling.storeBillingStatus === STORE_BILLING_STATUS.ACTIVE_SUBSCRIPTION
  );
};

export { handleIsStripeSubscriptionActive };
